import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";
import { toolInput } from "../tool-input";

export const reviewToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.VISUAL_TESTS_RUN, () => labelOnly("Ran the visual tests")],
  [HOST_TOOL_NAMES.VISUAL_TESTS_STATUS, () => labelOnly("Read the visual run")],
  [
    HOST_TOOL_NAMES.REVIEW_SCOPE,
    (record) => {
      const base = toolInput.str(record.base);
      const head = toolInput.str(record.head);
      return labelOnly(
        base && head
          ? `Scoped the review of ${toolInput.truncate(`${base}...${head}`, 60)}`
          : "Scoped the review",
      );
    },
  ],
  [
    HOST_TOOL_NAMES.FILTER_REVIEW_FINDINGS,
    (record) => {
      const count = Array.isArray(record.findings) ? record.findings.length : 0;
      return labelOnly(
        count > 0
          ? `Fact-checked ${count} review finding${count === 1 ? "" : "s"}`
          : "Fact-checked the review findings",
      );
    },
  ],
  [
    HOST_TOOL_NAMES.SUBMIT_REVIEW_SUMMARY,
    () => labelOnly("Drew the change summary"),
  ],
];
